'use client';

import Link from 'next/link';
import { Twitter } from 'lucide-react';
import { useIsMacDesktop } from '@/lib/useIsMacDesktop';
import { cn } from '@/lib/cn';

export function Footer() {
  const currentYear = new Date().getFullYear();
  const supportUrl = process.env.NEXT_PUBLIC_SUPPORT_URL;
  const isMacDesktop = useIsMacDesktop();

  return (
    <footer className="relative mt-auto" style={{ borderTop: '1px solid var(--color-border-subtle)' }}>
      <div className="container mx-auto px-4 py-8">
        <div className={cn(
          "flex flex-col sm:flex-row justify-center gap-12 sm:gap-20",
          "text-center"
        )}>
          {/* Product */}
          <div>
            <h4 className="text-xs font-semibold uppercase tracking-wider mb-3" style={{ color: 'var(--color-text-secondary)' }}>Product</h4>
            <div className="flex flex-col items-center gap-2">
              <Link href="/landing" className="text-sm transition-colors" style={{ color: 'var(--color-text-muted)' }}>
                Landing
              </Link>
              <Link href="/faq" className="text-sm transition-colors" style={{ color: 'var(--color-text-muted)' }}>
                FAQ
              </Link>
              <Link href="/changelog" className="text-sm transition-colors" style={{ color: 'var(--color-text-muted)' }}>
                Changelog
              </Link>
              {isMacDesktop && (
                <Link href="/download" className="text-sm transition-colors" style={{ color: 'var(--color-text-muted)' }}>
                  Download
                </Link>
              )}
            </div>
          </div>

          {/* Company */}
          <div>
            <h4 className="text-xs font-semibold uppercase tracking-wider mb-3" style={{ color: 'var(--color-text-secondary)' }}>Company</h4>
            <div className="flex flex-col items-center gap-2">
              {supportUrl && (
                <a
                  href={supportUrl}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-sm transition-colors"
                  style={{ color: 'var(--color-text-muted)' }}
                >
                  Support
                </a>
              )}
            </div>
          </div>

          {/* Social */}
          <div>
            <h4 className="text-xs font-semibold uppercase tracking-wider mb-3" style={{ color: 'var(--color-text-secondary)' }}>Social</h4>
            <div className="flex gap-3 justify-center">
              <a
                href="https://x.com/equity_labs_app"
                target="_blank"
                rel="noopener noreferrer"
                className="transition-colors p-1.5 rounded-lg hover:bg-[var(--color-surface-secondary)]"
                style={{ color: 'var(--color-text-muted)' }}
                title="Follow us on X"
              >
                <Twitter size={18} />
              </a>
            </div>
          </div>
        </div>

        <div className="mt-6 pt-4" style={{ borderTop: '1px solid var(--color-border-subtle)' }}>
          <p className="text-sm text-center" style={{ color: 'var(--color-text-muted)' }}>
            &copy; {currentYear} EquityLabs. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
}
